var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.apiAccomplish
    ? _c(
        "div",
        { staticClass: "travel" },
        [
          _c(
            "TransparentHeader",
            {
              attrs: {
                scrollHeight: 100,
                color: "#00D7AA",
                titleColor: "#FFFFFF",
                titleCustomOpacity: 1,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "title-switch-wrap",
                  attrs: { slot: "title" },
                  slot: "title",
                },
                [
                  _c("div", { staticClass: "item-tab travel-tab" }, [
                    _vm._v(" 同程旅行 "),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass: "item-tab taxi-tab",
                      on: { click: _vm.gotoTaxi },
                    },
                    [_vm._v(" 同程打车 ")]
                  ),
                ]
              ),
              _c("div", { attrs: { slot: "right-btn" }, slot: "right-btn" }),
            ]
          ),
          _c("div", { staticClass: "box-wrap" }, [
            _c("div", { staticClass: "box-bottom-wrap" }, [
              _c(
                "div",
                { staticClass: "coupon-wrap", on: { click: _vm.couponClick } },
                [
                  _vm._m(0),
                  _vm._m(1),
                  _c("div", { staticClass: "status" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.couponStatus == 1 ? "已领取" : "未领取") +
                        " "
                    ),
                  ]),
                ]
              ),
              _c("div", [
                _c(
                  "div",
                  { staticClass: "agreement-wrap" },
                  [
                    _c("van-checkbox", {
                      attrs: { "icon-size": "16" },
                      model: {
                        value: _vm.agreementChecked,
                        callback: function ($$v) {
                          _vm.agreementChecked = $$v
                        },
                        expression: "agreementChecked",
                      },
                    }),
                    _c("li", { staticClass: "text" }, [
                      _c("span", { staticClass: "left-text" }, [
                        _vm._v("我已阅读并同意遵守"),
                      ]),
                      _c("span", { on: { click: _vm.privacyClick } }, [
                        _vm._v("《隐私协议》"),
                      ]),
                      _vm._v("、"),
                      _c("span", { on: { click: _vm.agreementClick } }, [
                        _vm._v("《用户协议》"),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]),
              _vm.couponStatus == 1
                ? _c(
                    "div",
                    {
                      staticClass: "btn-wrap",
                      on: { click: _vm.jumpMiniProgram },
                    },
                    [
                      _c("img", {
                        staticClass: "btn",
                        attrs: {
                          src: require("../../../assets/img/202209/travel/btn.png"),
                          alt: "",
                        },
                      }),
                    ]
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "change-mobile-btn",
                  on: { click: _vm.changeMobileClick },
                },
                [_vm._v(" 更换手机号领取 ")]
              ),
            ]),
          ]),
          _vm._m(2),
          _c(
            "van-dialog",
            {
              attrs: { title: "", showConfirmButton: false },
              model: {
                value: _vm.changeMobileModelShow,
                callback: function ($$v) {
                  _vm.changeMobileModelShow = $$v
                },
                expression: "changeMobileModelShow",
              },
            },
            [
              _c("div", { staticClass: "dialog-wrap" }, [
                _c("li", { staticClass: "title" }, [_vm._v("更换手机号领取")]),
                _c("div", [
                  _c("li", { staticClass: "label" }, [_vm._v("领取手机号")]),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.mobile,
                        expression: "mobile",
                      },
                    ],
                    staticClass: "input",
                    attrs: { type: "number" },
                    domProps: { value: _vm.mobile },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.mobile = $event.target.value
                      },
                    },
                  }),
                ]),
                _c(
                  "div",
                  { staticClass: "btn", on: { click: _vm.confirmReceive } },
                  [_vm._v(" 确认领取 ")]
                ),
              ]),
              _c("img", {
                staticClass: "dialog-close",
                attrs: {
                  src: require("../../../assets/img/202209/travel/close.png"),
                  alt: "",
                },
                on: {
                  click: function ($event) {
                    _vm.changeMobileModelShow = false
                  },
                },
              }),
            ]
          ),
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "loading-wrap" },
        [_c("van-loading", [_vm._v("加载中...")])],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "price-wrap" }, [
      _c("span", { staticClass: "symbol" }, [_vm._v("￥")]),
      _c("span", { staticClass: "price" }, [_vm._v("216")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "title-wrap" }, [
      _c("li", { staticClass: "title" }, [_vm._v("同程旅行出行权益劵包")]),
      _c("li", { staticClass: "desc" }, [_vm._v("最多含9张出行优惠券")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "rule-wrap" }, [
      _c("li", { staticClass: "title" }, [_vm._v("活动说明")]),
      _c("p", [
        _vm._v(
          "1、优惠券默认发放的账号为高佣联盟绑定的手机号，请在同程旅行app或者同程旅行小程序登录的手机号和高佣联盟登录的手机号保持一致。"
        ),
      ]),
      _c("p", [_vm._v("2、如果手机号不同，请《更换手机号领取》即可。")]),
      _c("p", [
        _vm._v(
          "3、领取优惠券如何使用：在同程旅行app或者同程旅行小程序下单支付时抵扣使用。 "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }